export function rampGain(
  outputFrame: number,
  totalFrames: number,
  rampFrames: number,
): number {
  if (rampFrames <= 0 || totalFrames <= 1) return 1;
  const startGain = Math.min(1, outputFrame / rampFrames);
  const endGain = Math.min(1, (totalFrames - 1 - outputFrame) / rampFrames);
  return Math.max(0, Math.min(startGain, endGain));
}

export function applyBoundaryRamp(
  planarData: Float32Array,
  channels: number,
  chunkFrames: number,
  outputStartFrame: number,
  totalFrames: number,
  rampFrames: number,
): void {
  if (rampFrames <= 0) return;
  for (let frame = 0; frame < chunkFrames; frame += 1) {
    const gain = rampGain(outputStartFrame + frame, totalFrames, rampFrames);
    if (gain === 1) continue;
    for (let channel = 0; channel < channels; channel += 1) {
      planarData[channel * chunkFrames + frame] *= gain;
    }
  }
}
